import React from 'react'
import {Row, Col, Typography} from 'antd';
import { Icon } from '@ant-design/compatible';

const VendedorDetalhePedido = ({ order }) => {
  return (
    <div>
      <Typography.Title level={2}>Vendedor</Typography.Title>

      <Row type={"flex"} gutter={14}>
        <Col>
          <Icon type="bank" />
        </Col>
        <Col>
          <Typography.Text>{order.resaleName}</Typography.Text>
        </Col>
      </Row>

      <Row type={"flex"} gutter={14}>
        <Col>
          <Icon type="user" />
        </Col>
        <Col>
          <Typography.Text>{order.salesMan.name}</Typography.Text>
        </Col>
      </Row>

      <Row type={"flex"} gutter={14}>
        <Col>
          <Icon type="phone"/>
        </Col>
        <Col>
          <Typography.Text>{order.salesMan.phone}</Typography.Text>
        </Col>
      </Row>
    </div>
  )
}

export default VendedorDetalhePedido
